import { Asterisk, HelpCircle } from 'lucide-react'
import type { SchemaField } from '../../../../types/schede'

interface FieldWrapperProps {
  field: SchemaField
  error?: string
  children: React.ReactNode
}

export default function FieldWrapper({ field, error, children }: FieldWrapperProps) {
  return (
    <div className="mb-1">
      <label className="text-xs font-medium flex items-center gap-1 mb-1">
        {field.label}
        {field.required && <Asterisk className="w-2.5 h-2.5" style={{ color: 'var(--color-danger, #ef4444)' }} />}
        {field.help_text && (
          <span title={field.help_text} className="cursor-help">
            <HelpCircle className="w-3 h-3" style={{ color: 'var(--color-text-tertiary)' }} />
          </span>
        )}
      </label>
      {children}
      {error && (
        <p className="text-[10px] mt-0.5" style={{ color: 'var(--color-danger, #ef4444)' }}>{error}</p>
      )}
    </div>
  )
}
